const discountInPercentage = (originalPrice, salePrice) => {
    if (!originalPrice || typeof salePrice !== "number") {
        return null;
    }

    const diff = originalPrice - salePrice;
    const amount = diff / originalPrice;

    return Math.round(amount * 100);
};

export default discountInPercentage;
